export default [
    {
        id: 23285,
        code: 'ACU',
        name: 'Acústica',
    },

    {
        id: 23287,
        code: 'ARQ',
        name: 'Arquitetura',
    },
    {
        id: 23299,
        code: 'CLI',
        name: 'Cliente',
    },
    {
        id: 23288,
        code: 'ELE',
        name: 'Eléctrica',
    },
    {
        id: 23289,
        code: 'ELV',
        name: 'Elevadores',
    },
    {
        id: 23292,
        code: 'FUN',
        name: 'Fundação',
    },
    {
        id: 23295,
        code: 'INT',
        name: 'Interiores',
    },
    {
        id: 23296,
        code: 'PSG',
        name: 'Paisagismo',
    },
    {
        id: 23298,
        code: 'SEG',
        name: 'Segurança',
    },
]
